var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCcs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.777,
    height: 46,
    viewBox: "0 0 116.777 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Primary_Logo_SVG",
    "data-name": "Primary Logo SVG",
    transform: "translate(0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28200",
    "data-name": "Group 28200",
    transform: "translate(9.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5312",
    "data-name": "Path 5312",
    d: "M181.578,210.339c-3.2-7.922-10.249-13.425-18.432-13.425-8.156,0-15.185,5.469-18.4,13.351a8.291,8.291,0,0,1,2.1.521c2.928-6.965,9.125-11.771,16.3-11.771,7.239,0,13.485,4.889,16.381,11.953.105-.049.211-.1.32-.143a8.784,8.784,0,0,1,1.731-.485",
    transform: "translate(-144.589 -196.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5313",
    "data-name": "Path 5313",
    d: "M162.207,382.27l0-.008c.054,0,.108.008.163.008a2.383,2.383,0,1,0-2.38-2.451c-6.2-.971-11.4-5.548-13.948-11.835a7.792,7.792,0,0,1-2.147.549c3.109,8.009,10.125,13.625,18.309,13.737",
    transform: "translate(-143.898 -336.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5324",
    "data-name": "Path 5324",
    d: "M342.008,397.815a1.556,1.556,0,0,1-.227.87,1.748,1.748,0,0,1-.719.594,2.19,2.19,0,0,1-.918.2q-2.152-.015-2.207-1.713h1.007a.761.761,0,0,0,.343.637,1.215,1.215,0,0,0,.722.2,1.344,1.344,0,0,0,.7-.177.528.528,0,0,0,.3-.466q.006-.452-.77-.642a14.348,14.348,0,0,1-1.445-.4,1.29,1.29,0,0,1-.764-1.271,1.537,1.537,0,0,1,.231-.816,1.459,1.459,0,0,1,.68-.555,2.334,2.334,0,0,1,.945-.19,2.165,2.165,0,0,1,1.324.4,1.558,1.558,0,0,1,.655,1.259h-.993a.756.756,0,0,0-.338-.587,1.119,1.119,0,0,0-.649-.184,1.238,1.238,0,0,0-.587.135.542.542,0,0,0-.317.481q0,.431.785.623,1.321.325,1.459.388a1.236,1.236,0,0,1,.784,1.2",
    transform: "translate(-301.965 -357.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5325",
    "data-name": "Path 5325",
    d: "M412.084,395.832h-1.5v4.188h-1.042v-4.188h-1.49v-.9h4.029Zm0,0",
    transform: "translate(-359.083 -358.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5326",
    "data-name": "Path 5326",
    d: "M482.747,398.28a1.817,1.817,0,0,1-.538,1.429,2.114,2.114,0,0,1-1.449.453,1.983,1.983,0,0,1-1.731-.765,1.812,1.812,0,0,1-.282-1.061v-3.4H479.8v3.3a1.133,1.133,0,0,0,.221.729.8.8,0,0,0,.669.3.874.874,0,0,0,.994-.984v-3.346h1.062Zm0,0",
    transform: "translate(-416.668 -358.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5327",
    "data-name": "Path 5327",
    d: "M553.037,396.03a1.542,1.542,0,0,0-.983-.233c-.1,0-.233,0-.4.01s-.273.011-.329.011v3.325h1.025a.953.953,0,0,0,.858-.55,2.383,2.383,0,0,0,.277-1.193,1.74,1.74,0,0,0-.45-1.369m.637,3.58a1.7,1.7,0,0,1-1.173.4h-2.187v-5.086h2.208a1.872,1.872,0,0,1,1.145.332,1.948,1.948,0,0,1,.655.891,3.317,3.317,0,0,1,.207,1.2,3.687,3.687,0,0,1-.221,1.281,2.259,2.259,0,0,1-.634.976",
    transform: "translate(-474.969 -358.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    "data-name": "Path 5328",
    d: "M623.213,400.021h-1.041v-5.087h1.041Zm0,0",
    transform: "translate(-533.506 -358.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5329",
    "data-name": "Path 5329",
    d: "M681.032,396.853q0-1.853-1.373-1.861a1.14,1.14,0,0,0-1.008.544,2.121,2.121,0,0,0-.317,1.16,2.2,2.2,0,0,0,.352,1.259,1.244,1.244,0,0,0,1.083.61,1.087,1.087,0,0,0,.883-.439,1.981,1.981,0,0,0,.379-1.273m1.029-.064a2.9,2.9,0,0,1-.642,2.009,2.136,2.136,0,0,1-1.67.68,2.223,2.223,0,0,1-1.81-.757,3.171,3.171,0,0,1-.632-2.087,2.65,2.65,0,0,1,.634-1.839,2.254,2.254,0,0,1,1.753-.743,2.206,2.206,0,0,1,1.63.658,2.837,2.837,0,0,1,.738,2.08",
    transform: "translate(-578.417 -357.504)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28201",
    "data-name": "Group 28201",
    transform: "translate(-0.009 12.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5314",
    "data-name": "Path 5314",
    d: "M108.338,278.319a8.009,8.009,0,0,1-3.973,5.969,7.889,7.889,0,0,1-3.872.934,8.631,8.631,0,0,1-4.284-1.064,7.389,7.389,0,0,1-3-3.217,11.724,11.724,0,0,1-1.094-5.345,13.625,13.625,0,0,1,.7-4.541A7.682,7.682,0,0,1,97.1,266.2a9.039,9.039,0,0,1,3.44-.649,8.42,8.42,0,0,1,3.9.883,6.767,6.767,0,0,1,3.9,5.761h-3.822a4.214,4.214,0,0,0-1.48-2.44,3.882,3.882,0,0,0-2.442-.856,3.933,3.933,0,0,0-3.416,1.79,8.093,8.093,0,0,0-1.24,4.7,8.686,8.686,0,0,0,.962,4.256,3.724,3.724,0,0,0,3.467,2.179q3.39,0,4.15-3.5Zm0,0",
    transform: "translate(-92.116 -265.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5315",
    "data-name": "Path 5315",
    d: "M190.118,299.847a4.281,4.281,0,0,1-1.863.7,7.64,7.64,0,0,0-1.963.544,1.776,1.776,0,0,0-.932,1.713,1.389,1.389,0,0,0,1.586,1.557,3.685,3.685,0,0,0,1.51-.35,2.6,2.6,0,0,0,1.712-2.842q0-.233-.025-.675c-.017-.295-.025-.51-.025-.649m3.77,6.747h-3.313a4.906,4.906,0,0,1-.329-1.116,5.019,5.019,0,0,1-3.947,1.4A5.123,5.123,0,0,1,183.21,306a3.5,3.5,0,0,1-1.418-3.01,3.948,3.948,0,0,1,2.151-3.892,14.931,14.931,0,0,1,4.024-.882q2.151-.286,2.151-1.194a1.522,1.522,0,0,0-.645-1.285,2.456,2.456,0,0,0-1.5-.479,2.4,2.4,0,0,0-1.519.493,2.11,2.11,0,0,0-.81,1.531h-3.391a5.962,5.962,0,0,1,.772-2.724,4.155,4.155,0,0,1,2.088-1.609,8.356,8.356,0,0,1,3.036-.52q5.743.053,5.743,5.632Zm0,0",
    transform: "translate(-165.167 -287.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5316",
    "data-name": "Path 5316",
    d: "M258.387,286.872H254.82V268.215h3.567Zm0,0",
    transform: "translate(-224.657 -267.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5317",
    "data-name": "Path 5317",
    d: "M285.685,286.872h-3.568V268.215h3.568Zm0,0",
    transform: "translate(-246.893 -267.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5318",
    "data-name": "Path 5318",
    d: "M323.986,278.318a8.01,8.01,0,0,1-3.973,5.969,7.889,7.889,0,0,1-3.872.934,8.63,8.63,0,0,1-4.283-1.064,7.394,7.394,0,0,1-3-3.218,11.739,11.739,0,0,1-1.093-5.345,13.626,13.626,0,0,1,.7-4.541,7.682,7.682,0,0,1,4.281-4.853,9.049,9.049,0,0,1,3.441-.649,8.42,8.42,0,0,1,3.9.883,6.767,6.767,0,0,1,3.9,5.761h-3.821a4.217,4.217,0,0,0-1.48-2.44,3.883,3.883,0,0,0-2.442-.856,3.933,3.933,0,0,0-3.416,1.79,8.1,8.1,0,0,0-1.24,4.7,8.688,8.688,0,0,0,.962,4.256,3.725,3.725,0,0,0,3.467,2.179q3.39,0,4.15-3.5Zm0,0",
    transform: "translate(-267.785 -265.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5319",
    "data-name": "Path 5319",
    d: "M406.086,298.233a3.419,3.419,0,0,0-.923-2.186,2.522,2.522,0,0,0-1.835-.8,2.366,2.366,0,0,0-1.746.746,3.773,3.773,0,0,0-1.012,2.238Zm3.644,2.309h-9.286a4.011,4.011,0,0,0,1.063,2.647,2.74,2.74,0,0,0,1.973.778,2.918,2.918,0,0,0,1.544-.415,1.9,1.9,0,0,0,.886-1.116h3.643a5.944,5.944,0,0,1-2.176,3.256,6.1,6.1,0,0,1-3.72,1.155q-6.756,0-6.756-7.552a7.356,7.356,0,0,1,1.709-5.1,6.1,6.1,0,0,1,4.795-1.907q6.326,0,6.326,8.251",
    transform: "translate(-340.398 -287.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5320",
    "data-name": "Path 5320",
    d: "M483.511,306.372h-3.568v-8.356a3.636,3.636,0,0,0-.43-2.05,2.245,2.245,0,0,0-1.9-.7q-2.758,0-2.758,3.191v7.914h-3.568V292.541H474.7v1.3a4.23,4.23,0,0,0,.025.753.023.023,0,0,1,.025-.026,4.431,4.431,0,0,1,1.809-1.778,5.173,5.173,0,0,1,2.492-.635,4.142,4.142,0,0,1,3.9,2.154,5.206,5.206,0,0,1,.557,2.491Zm0,0",
    transform: "translate(-400.995 -287.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5321",
    "data-name": "Path 5321",
    d: "M554.447,284.743a18.319,18.319,0,0,1-.2,3.14,5.584,5.584,0,0,1-1.189,2.8,5.157,5.157,0,0,1-4.049,1.608,6.144,6.144,0,0,1-2.935-.7,4.476,4.476,0,0,1-2.05-2.154,7.27,7.27,0,0,1-.531-2.829V274.234h3.568v3.711h7.389v2.622h-7.389v5.682a6.378,6.378,0,0,0,.152,1.608,1.995,1.995,0,0,0,3.217.7q.7-.779.7-3.348v-2.518h3.315Zm0,0",
    transform: "translate(-459.811 -272.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5322",
    "data-name": "Path 5322",
    d: "M614.643,298.233a3.419,3.419,0,0,0-.923-2.186,2.523,2.523,0,0,0-1.835-.8,2.366,2.366,0,0,0-1.746.746,3.765,3.765,0,0,0-1.012,2.238Zm3.643,2.309H609a4.012,4.012,0,0,0,1.063,2.647,2.738,2.738,0,0,0,1.973.778,2.918,2.918,0,0,0,1.544-.415,1.9,1.9,0,0,0,.885-1.116h3.644a5.944,5.944,0,0,1-2.176,3.256,6.106,6.106,0,0,1-3.72,1.155q-6.755,0-6.756-7.552a7.356,7.356,0,0,1,1.709-5.1,6.1,6.1,0,0,1,4.795-1.907q6.325,0,6.326,8.251",
    transform: "translate(-510.291 -287.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5323",
    "data-name": "Path 5323",
    d: "M687.663,296.281a6.56,6.56,0,0,0-.987-.078q-3.264,0-3.264,3.321v7.19h-3.568V292.882h3.365v1.064a2.615,2.615,0,0,0,.025.6.3.3,0,0,1,.076-.051,7.628,7.628,0,0,1,1.569-1.4,4.518,4.518,0,0,1,2.3-.519h.481Zm0,0",
    transform: "translate(-570.886 -287.561)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs);
export default __webpack_public_path__ + "static/media/CCS.ddf7a957d4449749526f7c29552bdad1.svg";
export { ForwardRef as ReactComponent };